import React, { Component } from 'react'
import { Row, Col, Modal } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'
import moment from 'moment'

import Button from './Button'
import LinkButton from './LinkButton'
import DocumentLink from './DocumentLink'
import Notificator from './Notificator'
import Wopi360Recipients from './Wopi360Recipients'
import Wopi360InvitationForm from './Wopi360InvitationForm'
import Wopi360WhoToInvite from './Wopi360WhoToInvite'

import invitationStyles from './styles/invitation.scss'
import styles from './styles/app.scss'

export default class Wopi360TargetDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      closeTestModalActive: false,
      copyTestLink: null,
      sendRemindersModalOpen: false,
      unansweredTargetModalOpen: false
    }
  }

  handleCloseTestModalOpen = () => {
    this.setState({
      closeTestModalActive: true
    })
  }

  handleCloseTestModalClose = e => {
    e.preventDefault()

    this.setState({
      closeTestModalActive: false
    })
  }

  handleCloseTargetClick = () => {
    const hasTargetAnswered = this.props.wopi360TargetDetails.recipients.some(
      recipient => recipient.isTarget && !!recipient.finishedAt
    )

    if (!hasTargetAnswered) {
      this.setState({ closeTestModalActive: false, unansweredTargetModalOpen: true })
      return
    }

    this.props.onCloseTarget()

    this.setState({
      closeTestModalActive: false
    })
  }

  handleCloseUnansweredTargetClick = () => {
    this.props.onCloseTarget()

    this.setState({
      unansweredTargetModalOpen: false
    })
  }

  handleCopyTestLinkModalOpen = recipient => {
    this.setState({
      copyTestLink: {
        uuid: recipient.uuid,
        email: recipient.email
      }
    })
  }

  handleCopyTestLinkModalClose = e => {
    this.setState({
      copyTestLink: null
    })
  }

  handleSendInvitations = (language, recipients, message, manager) => {
    const { onSendInvitations, wopi360TargetDetails } = this.props

    onSendInvitations(wopi360TargetDetails.uuid, language, recipients, message, manager)
  }

  handleDeleteRecipient = recipient => {
    this.props.onDeleteInvitation(recipient.uuid)
  }

  isRecipientDeleted = recipient => this.props.deletedInvitations.includes(recipient.uuid)

  isRecipientReminded = recipient => this.props.sentReminders.includes(recipient.uuid)

  isRecipientFinished = recipient => !!recipient.finishedAt

  shouldRecipientReceiveReminder = recipient =>
    !this.isRecipientDeleted(recipient) &&
    !this.isRecipientReminded(recipient) &&
    !this.isRecipientFinished(recipient)

  isSendRemindersDisabled = () => {
    const { wopi360TargetDetails: { recipients } } = this.props

    const possibleRecipients = recipients.filter(recipient =>
      this.shouldRecipientReceiveReminder(recipient)
    )

    return !recipients || possibleRecipients.length === 0
  }

  handleSendReminders = () => {
    const { wopi360TargetDetails: { recipients }, onSendReminders } = this.props

    const uuids = recipients
      .filter(recipient => this.shouldRecipientReceiveReminder(recipient))
      .map(recipient => recipient.uuid)

    onSendReminders(uuids)
    this.setState({ sendRemindersModalOpen: false })
  }

  handleSendRemindersModalOpen = () => {
    this.setState({ sendRemindersModalOpen: true })
  }

  handleSendRemindersModalClose = e => {
    e.preventDefault()

    this.setState({ sendRemindersModalOpen: false })
  }

  handleUnansweredTargetModalOpen = () => {
    this.setState({ unansweredTargetModalOpen: true })
  }

  handleUnansweredTargetModalClose = e => {
    e.preventDefault()

    this.setState({ unansweredTargetModalOpen: false })
  }

  render() {
    const {
      wopi360TargetDetails,
      currentAccountOption,
      currentLanguage,
      sentInvitations,
      deletedInvitations,
      sentReminders
    } = this.props

    moment.locale(currentLanguage)

    const deadlineUpcoming = moment().isBefore(moment(wopi360TargetDetails.deadlineAt))
    const deadlinePassed = moment().isAfter(moment(wopi360TargetDetails.deadlineAt))

    const finishedRecipients = wopi360TargetDetails.recipients.filter(
      recipient => recipient.finishedAt
    ).length
    const totalRecipients = wopi360TargetDetails.recipients.length

    const organisationAndRole = [wopi360TargetDetails.organisation, wopi360TargetDetails.role]
      .filter(x => x)
      .join(', ')

    return (
      <div>
        <Modal show={this.state.closeTestModalActive} onHide={this.handleCloseTestModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('close_test')}?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {deadlineUpcoming && (
              <p>
                {i18next.t('close_test_confirm_deadline_upcoming')}{' '}
                <strong>{moment(wopi360TargetDetails.deadlineAt).format('dddd l')}</strong>.
              </p>
            )}

            {deadlinePassed && (
              <p>
                {i18next.t('close_test_confirm_deadline_passed')}{' '}
                <strong>{moment(wopi360TargetDetails.deadlineAt).format('dddd l')}</strong>.
              </p>
            )}

            <p>
              <strong>
                {finishedRecipients}/{totalRecipients}
              </strong>{' '}
              {i18next.t('recipients_have_answered')}.
            </p>

            <Button text={i18next.t('close_test')} onClick={this.handleCloseTargetClick} />

            <span style={{ marginLeft: 5 }}>
              {i18next.t('or')}{' '}
              <Link to="#" onClick={this.handleCloseTestModalClose}>
                {i18next.t('cancel')}
              </Link>
            </span>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.unansweredTargetModalOpen}
          onHide={this.handleUnansweredTargetModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('close_test')}?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{i18next.t('close_test_target_unanswered_description')}</p>
            <p style={{ marginBottom: 20 }}>
              <strong>{i18next.t('close_test_target_unanswered_confirmation')}</strong>
            </p>
            <Button
              text={i18next.t('close_test')}
              onClick={this.handleCloseUnansweredTargetClick}
            />

            <span style={{ marginLeft: 5 }}>
              {i18next.t('or')}{' '}
              <Link to="#" onClick={this.handleUnansweredTargetModalClose}>
                {i18next.t('cancel')}
              </Link>
            </span>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.copyTestLink !== null} onHide={this.handleCopyTestLinkModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('link_to_wopi360_test')}</Modal.Title>
          </Modal.Header>

          {this.state.copyTestLink && (
            <Modal.Body>
              <p>
                {i18next.t('wopi360_test_link_description_sent_to')}&nbsp;<strong>
                  {this.state.copyTestLink.email}
                </strong>.
              </p>

              <pre style={{ marginBottom: 20 }}>
                {window.location.protocol}//{window.location.host}/wopi360/{
                  this.state.copyTestLink.uuid
                }
              </pre>

              <Button text={i18next.t('close')} onClick={this.handleCopyTestLinkModalClose} />
            </Modal.Body>
          )}
        </Modal>

        <Modal show={this.state.sendRemindersModalOpen} onHide={this.handleSendRemindersModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('send_reminders_to_participants')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{i18next.t('send_reminders_to_participants_description')}</p>
            <Button text={i18next.t('send_invitations')} onClick={this.handleSendReminders} />
            <span style={{ marginLeft: 5 }}>
              {i18next.t('or')}{' '}
              <Link to="#" onClick={this.handleSendRemindersModalClose}>
                {i18next.t('cancel')}
              </Link>
            </span>
          </Modal.Body>
        </Modal>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={3}>
                <header>
                  <h1>{i18next.t('wopi360')}</h1>
                </header>
              </Col>

              <Col md={9} style={{ textAlign: 'right' }}>
                {currentAccountOption && (
                  <LinkButton
                    to={`/target/${wopi360TargetDetails.uuid}/edit`}
                    text={i18next.t('edit_targets_basic_information')}
                    style={{ marginRight: 20 }}
                  />
                )}

                {!wopi360TargetDetails.closedAt && (
                  <Button text={i18next.t('close_test')} onClick={this.handleCloseTestModalOpen} />
                )}

                {wopi360TargetDetails.closedAt && (
                  <DocumentLink
                    href={`/api/targets/${wopi360TargetDetails.uuid}/profiles/${currentLanguage}`}
                    text={i18next.t('download_pdf')}
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className={invitationStyles.wopi360TargetDetails}>
                  <Row>
                    <Col md={4}>
                      <p>
                        <strong>{i18next.t('target_person')}</strong>
                      </p>

                      <p>
                        <strong>
                          {wopi360TargetDetails.givenName} {wopi360TargetDetails.familyName}
                        </strong>
                        <br />
                        {organisationAndRole && (
                          <span>
                            {organisationAndRole}
                            <br />
                          </span>
                        )}
                        {wopi360TargetDetails.email}
                      </p>
                    </Col>

                    <Col md={4}>
                      <p>
                        <strong>{i18next.t('wopi360_test_status')}</strong>
                      </p>

                      <p>
                        {i18next.t('test_deadline')}{' '}
                        <span className={styles.orange}>
                          {moment(wopi360TargetDetails.deadlineAt).format('dd l')}
                        </span>
                        <br />
                        {i18next.t('opened_at')}{' '}
                        {moment(wopi360TargetDetails.createdAt).format('dd l LT')}
                        <br />
                        {wopi360TargetDetails.closedAt ? (
                          <span>
                            {i18next.t('closed_at')}{' '}
                            <strong>
                              {moment(wopi360TargetDetails.closedAt).format('dd l LT')}
                            </strong>
                          </span>
                        ) : (
                          ''
                        )}
                      </p>
                    </Col>

                    <Col md={4}>
                      <p>
                        <strong>{i18next.t('number_of_replies')}</strong>
                      </p>

                      <h2>
                        {finishedRecipients}/{totalRecipients}
                      </h2>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <h2>{i18next.t('invite_recipients')}</h2>

                {!sentInvitations.isEmpty() && (
                  <Notificator type="success">
                    <header>{i18next.t('invitation_emails_sent')}</header>

                    <p>
                      {i18next.t('invitations_sent_to')} <i>{sentInvitations.join(', ')}</i>
                    </p>
                  </Notificator>
                )}

                <Row>
                  <Col md={12}>
                    <Wopi360InvitationForm
                      wopi360TargetDetails={wopi360TargetDetails}
                      deletedInvitations={deletedInvitations}
                      currentAccount={currentAccountOption}
                      onSendInvitations={this.handleSendInvitations}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div style={{ paddingTop: '20px' }}>
                      <Wopi360Recipients
                        wopi360TargetDetails={wopi360TargetDetails}
                        deletedInvitations={deletedInvitations}
                        currentLanguage={currentLanguage}
                        onCopyLinkClick={this.handleCopyTestLinkModalOpen}
                        onDeleteClick={this.handleDeleteRecipient}
                        sendReminderEmail={this.props.onSendReminders}
                        sentReminders={sentReminders}
                      />
                    </div>

                    <div
                      style={{
                        paddingBottom: '30px',
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}
                    >
                      <Button
                        disabled={this.isSendRemindersDisabled()}
                        onClick={this.handleSendRemindersModalOpen}
                        text={i18next.t('send_reminders_to_participants')}
                      />
                    </div>

                    <div style={{ paddingBottom: '20px' }}>
                      <Wopi360WhoToInvite wopi360TargetDetails={wopi360TargetDetails} />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetDetails.js